export class GA {
  static gaLoaded(cb) {
    const interval = setInterval(() => {
      if (window.hasOwnProperty('ga')) {
        clearInterval(interval);
        cb(ga);
      }
    }, 500);
  }
}
